import { Typography } from '@breetometer/components';
import { useCallback } from 'react';

import AvailableAccount from './AvailableAccount';

const Child = () => {
	const switchUserAccount = useCallback(() => {
		console.info('switching user account');
	}, []);

	return (
		<div className='available-accounts'>
			<Typography as='h4'>Available Accounts</Typography>
			<div className='list'>
				<AvailableAccount
					accountName=''
					imgSrc=''
					accountRole='owner'
					onClick={switchUserAccount}
				/>
			</div>
		</div>
	);
};

export default Child;
